import {Component, OnInit, AfterViewInit, Input, EventEmitter, ElementRef, OnChanges, SimpleChanges} from '@angular/core';


@Component({
	selector: 'component-progress-bar',
	templateUrl: './component.progressBar.html',
	styleUrls: ['./component.progressBar.css']
})

export class ComponentProgressBar implements OnInit, AfterViewInit {

  @Input() theme: any; //主题
  @Input() type: string; //类型
  @Input() progress: number = 0; //进度
  @Input() isShowBar: boolean;
  @Input() isPC: boolean;
  @Input() isCamp: boolean;
  @Input() redDot: boolean;

  isShowInner: boolean = false;
  isShowRedDot: boolean = false;
  ctx:any; //canvas.getContext
  canvas: any; //canvas对象
  radius: number; //外环半径
  thickness: number;//圆环厚度
  innerRadius: number;//内环半径
  startAngle: number;//开始角度
  endAngle: number;//结束角度
  x: number;//圆心x坐标
  y: number;//圆心y坐标

  constructor(private el: ElementRef) {}

  ngOnInit() {
    setTimeout(()=>{
      this.renderOnInit();
    },500);
  }

  ngOnChanges(){
    setTimeout(()=>{
      this.renderOnInit();
    },500);
  }

  //初始化渲染
  renderOnInit(){
    if(this.type === 'circle'){
      this.x = this.theme.x ? this.theme.x : 0;
      this.y = this.theme.y ? this.theme.y : 0;
      this.radius = this.theme.radius ? this.theme.radius : 90;
      this.thickness = this.theme.thickness ? this.theme.thickness : 20;
      this.innerRadius = this.radius - this.thickness;
      this.startAngle = this.theme.startAngle ? this.theme.startAngle : 0;
      this.endAngle = this.theme.endAngle ? this.theme.endAngle : 360;
      this.canvas = this.el.nativeElement.querySelector('#tutorial');
      this.canvas.width = this.theme.width ? this.theme.width: 300;
      this.canvas.height = this.theme.height ? this.theme.height: 300;
      this.ctx = this.canvas.getContext('2d');
      this.ctx.translate(this.canvas.width / 2, this.canvas.height / 2); //将绘图原点移到画布中央
      let angleRadian = this.theme.angleRadian ? this.theme.angleRadian : 275;
      this.ctx.rotate(this.angle2Radian(angleRadian)) //将画布旋转275度
      this.ctx.fillStyle = "#eee"; //初始填充颜色
      this.renderRing(this.startAngle, this.endAngle);
      //进度条颜色 (下标为4的是透明色，下标0-3是填充色，单色设置一样即可)
      let lingrad = this.ctx.createLinearGradient(0, 0, 150, 150);
      let colors = this.theme.colors ?  this.theme.colors : ['#FFF','#000'];
      if(this.progress === 100){
        colors = [this.theme.colors[2],this.theme.colors[3]];
      }else if(this.progress === 0){
        colors = [this.theme.colors[4],this.theme.colors[4]]
      }
      lingrad.addColorStop(0, colors[0]);
      lingrad.addColorStop(1, colors[1]);
      this.ctx.fillStyle = lingrad;
      //开始绘画
      let tempAngle = this.startAngle;
      let total = 100; //总分
      let now = this.progress === 100 && this.progress > 3 ? this.progress : this.progress - 3; //当前分数
      let percent = now / total; //百分比
      let twoEndAngle = percent * 360 + this.startAngle;
      let step = (twoEndAngle - this.startAngle) / 80;
      let numberSpan = this.el.nativeElement.querySelector('.number');
      // let numberSpan = document.querySelector('.number');
      let inter = setInterval(() => {
        if (tempAngle > twoEndAngle) {
          clearInterval(inter);
          this.isShowRedDot = true;
        } else {
          // numberSpan.innerText = percent * 100;
          tempAngle += step;
        }
        this.renderRing(this.startAngle, tempAngle);
      },10);
    }else if(this.type === 'bar' && this.isShowBar){
      let target = this.el.nativeElement.querySelector('.progress-inner');
      let mark = this.el.nativeElement.querySelector('.progress-inner-mark');
      mark.style.left = this.progress > 3 ? this.progress -3+'%': this.progress+'%';
      target.style.width = this.progress+'%';
      target.style.backgroundColor = this.theme.color;
      target.style.borderRadius = this.theme.radius;
    }
  }

  //渲染函数
  renderRing(startAngle, endAngle) {
    this.ctx.beginPath();
    //绘制外环
    this.ctx.arc(this.x, this.y, this.radius, this.angle2Radian(startAngle), this.angle2Radian(endAngle));
    //计算外环与内环第一个连接处的中心坐标
    let oneCtrlPoint = this.calcRingPoint(this.x, this.y, this.innerRadius + this.thickness / 2, endAngle);
    //绘制外环与内环第一个连接处的圆环
    this.ctx.arc(oneCtrlPoint.x, oneCtrlPoint.y, this.thickness / 2, this.angle2Radian(-90), this.angle2Radian(270));
    //绘制内环
    this.ctx.arc(this.x, this.y, this.innerRadius, this.angle2Radian(endAngle), this.angle2Radian(startAngle), true);
    //计算外环与内环第二个连接处的中心坐标
    let twoCtrlPoint = this.calcRingPoint(this.x, this.y, this.innerRadius + this.thickness / 2, startAngle);
    //绘制外环与内环第二个连接处的圆环
    this.ctx.arc(twoCtrlPoint.x, twoCtrlPoint.y, this.thickness / 2, this.angle2Radian(-90), this.angle2Radian(270));
    this.ctx.fill()
    // ctx.stroke()
  }

  //计算圆环上点的坐标
  calcRingPoint(x, y, radius, angle){
    let res = {
      x: x + radius * Math.cos(angle * Math.PI / 180),
      y:y + radius * Math.sin(angle * Math.PI / 180)
    };
    return res;
  }

  //弧度转角度
  radian2Angle(radian){
    return 180 * radian / Math.PI;
  }

  //角度转弧度
  angle2Radian(angle){
    return angle * Math.PI / 180;
  }



  ngAfterViewInit() {

  }


}



// WEBPACK FOOTER //
// ./src/component-ui/progress-bar/component.progressBar.ts